export const getFullName = (name?: string, surname?: string) =>
  `${name || ''} ${surname || ''}`.trim();
